import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Form, Button } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';
import validator from 'validator';

const RouteCreateModel = ({ onShow, setRouteCreateModelShow, setRoutesModelShow, refreshData, refreshUserRoutes }) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });
  const [route_name, setRouteName] = useState('');
  const [ani, setAni] = useState('68889');
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [api_key, setAPIKey] = useState('');

  const handleClose = () => {
    setRouteCreateModelShow(false);
    setRoutesModelShow(true);
  };
  const handleSubmit = () => {
    if (!route_name || validator.isEmpty(route_name)) {
      setAlertState({
        message: 'Please enter route name',
        show: true,
        variant: 'danger',
      });
      return;
    }
    if (!username || validator.isEmpty(username)) {
      setAlertState({
        message: 'Please enter username',
        show: true,
        variant: 'danger',
      });
      return;
    }
    if (!password || validator.isEmpty(password)) {
      setAlertState({
        message: 'Please enter password',
        show: true,
        variant: 'danger',
      });
      return;
    }
    if (!api_key || validator.isEmpty(api_key)) {
      setAlertState({
        message: 'Please enter API Key',
        show: true,
        variant: 'danger',
      });
      return;
    }
    const payload = {
      route_name: route_name,
      ani: ani,
      username: username,
      password: password,
      api_key: api_key,
    };

    postRequest(`/admin/sms-gateway-create`, payload, access_token.token, (res) => {
      if (res.success) {
        refreshData();
        refreshUserRoutes();
        handleClose();
        setAlertState({
          message: 'Successfully create a new gateway route',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'There was an issue while creating new route',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={onShow} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add New Route</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Route Name</Form.Label>
              <Form.Control
                type="input"
                value={route_name}
                onChange={(event) => setRouteName(event.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Ani</Form.Label>
              <Form.Control
                type="input"
                value={ani}
                onChange={(event) => setAni(event.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>User Name</Form.Label>
              <Form.Control
                type="input"
                value={username}
                onChange={(event) => setUserName(event.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>API Key</Form.Label>
              <Form.Control
                type="input"
                value={api_key}
                onChange={(event) => setAPIKey(event.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
          <Button variant="primary" onClick={handleSubmit} style={{ minWidth: 160 }}>
            Save
          </Button>
          <Button variant="ghost" onClick={handleClose} style={{ minWidth: 160 }}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RouteCreateModel;
